export const formatNumber = (n, decimalPlaces = 2) => {
  if (typeof n !== 'number' || Number.isInteger(n)) {
    return n;
  }
  const fixed = Number(n.toFixed(decimalPlaces));
  return fixed && fixed % 1 ? fixed : Math.floor(n);
};

export default {};
